// Video Player Helper Functions

export function parseTimeParam(param) {
    if (!param) return null;
    if (param.includes(":")) {
        const parts = param.split(":").map(Number);
        if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
        if (parts.length === 2) return parts[0] * 60 + parts[1];
    }
    return parseInt(param, 10);
}

export function formatTime(sec) {
    if (!sec) return "0:00";
    const minutes = Math.floor(sec / 60);
    const seconds = Math.floor(sec % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function formatTimeHHMMSS(sec) {
    if (!sec) return "00:00";
    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor((sec % 3600) / 60);
    const seconds = Math.floor(sec % 60);
    
    if (hours > 0) {
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    } else {
        return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }
}

export function parseChaptersAPI(apiData) {
    if (!Array.isArray(apiData)) {
        console.warn("Chapters API response is not an array:", apiData);
        return [];
    }
    
    const chapters = apiData.map((chapter, index) => ({
        title: chapter.title,
        seconds: parseTimeParam(chapter.timestamp) || 0,
        endTimestamp: chapter.endTimestamp ? parseTimeParam(chapter.endTimestamp) : null
    }));
    
    return chapters;
}
